export default "__VITE_ASSET__AjV4NaHU__"